export { default as SectionHeading } from "./SectionHeading";
